import React from 'react';
import { InputGroup, InputGroupText, InputGroupAddon, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { deleteFee } from '../../API';
import { getCurrency, toggleOptionsMenu, blurCurrency } from '../../Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faHashtag, faDollarSign, faCheckSquare, faEllipsisH, faEdit, faEye, faUsers, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';

function FeePaymentCard(props) {

    return (
        <div className="card item-details">
            <div className="properties">
                <div className="svg-label tooltip-parent">
                    <i className="fas fa-asterisk"></i>
                    <span>{props.fee.account.accountNumber}</span>
                    <div className="tooltip-target">
                        Account Number
                        </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <i className="fas fa-city"></i>
                    <span>{props.fee.account.name}</span>
                    <div className="tooltip-target">
                        Account
                        </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faUsers} />
                    <span>{props.fee.division?.divisionName}</span>
                    <div className="tooltip-target">
                        DANR Program
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faIndustry} />
                    <span>{props.fee.facility}</span>
                    <div className="tooltip-target">
                        Facililty
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faHashtag} />
                    <span>{props.fee.identifier}</span>
                    <div className="tooltip-target">
                        EPA ID/Permit Number
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faFileAlt} />
                    <span>FY{props.fee.fiscalYear} - {props.fee.feeDescription}</span>
                    <div className="tooltip-target">
                        Description
                    </div>
                </div>
                <div className="svg-label tooltip-parent">
                    <FontAwesomeIcon icon={faDollarSign} />
                    <span>{getCurrency(props.fee.currentBalance)} / {getCurrency(props.fee.feeAmount)}</span>
                    <div className="tooltip-target">
                        Amount Balance/Total
                    </div>
                </div>
                <InputGroup className="tooltip-parent">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText><i className="fas fa-dollar-sign"></i></InputGroupText>
                    </InputGroupAddon>
                    <Input type="number" name="paymentAmount" value={props.feePayment.paymentAmount} onChange={e => props.updateFeePaymentAmount(props.feePayment.feeID, e.target.valueAsNumber)} onBlur={blurCurrency} />
                    <div className="tooltip-target">
                        Payment Amount
                    </div>
                </InputGroup>
            </div>
            <div className="actions">
            </div>
        </div>  
    );
}

export default FeePaymentCard;